import React from 'react';
import { ButtonProps } from '@lendi-ui/button';
import { ValidHex } from '@lendi-ui/commons/colours';

import { ClearButton } from './index.style';

interface LinkButtonProps extends Omit<ButtonProps, 'variant' | 'isInverse'> {
  color?: ValidHex;
  text: string;
}

export const LinkButton = (props: LinkButtonProps) => {
  const { color, text, ...rest } = props;
  return (
    <ClearButton textColor={color} variant={'primary'} isInverse data-component={text} {...rest}>
      {text}
    </ClearButton>
  );
};
